
<v-radio-group
    class="configurationModeSelection"
    :value="value"
    @change="onSelect"
    :column="false">
  <v-radio value="AUTO">
    <template slot="label">
      <div class="configOption">
        <h3 class="title">{{ $t("CONFIGURATOR_MODE_AUTO") }}</h3>
        <p>{{ autoChoiceSettingLabel }}</p>
      </div>
    </template>
  </v-radio>
  <v-radio value="DETAILED">
    <template slot="label">
      <div class="configOption">
        <h3 class="title">{{ $t("CONFIGURATOR_MODE_DETAILED") }}</h3>
        <p>{{ detailedChoiceSettingLabel }}</p>
      </div>
    </template>
  </v-radio>
</v-radio-group>
